import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {ApiResponse} from '../../api/api-response';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerXAdsService {
  private routePath = '/partner/x-ads';

  constructor(
    protected apiClient: ApiClientService,
  ) {
  }

  getConversionGoalsStatus(partnerId: number): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.get(this.routePath + '/' + partnerId + '/conversion-goal', {}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData().goals);
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  createConversionGoalsStatus(partnerId: number): Observable<void> {
    return new Observable<void>((subscriber) => {
      this.apiClient.post(this.routePath + '/' + partnerId + '/conversion-goal/create', {}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next();
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
